import {
    LongTermCalculatorApi,
    LongTermCalculatorBody,
    Configuration
} from 'hotdesk_typescript';

export class CalculatorService {
    private longTermCalculatorApi!: LongTermCalculatorApi;
    constructor(apiConfig: Configuration) {
        this.longTermCalculatorApi = new LongTermCalculatorApi(apiConfig);
    }

    async calculate(Long_term: LongTermCalculatorBody) {
        try {
            return await this.longTermCalculatorApi.calculateLongTerm(
                Long_term
            );
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}
